import React from 'react';
import DropClick from 'bloko/blocks/drop/Click';

import Info from './index';

function Click(props) {
    return <DropClick {...props} DropElement={Info} />;
}

export default Click;
